<template>
    <el-row ref="pdfReviewRef" class="pdf-review">
        <el-col :span="24">
            <el-row>
                <el-col :span="16">
                    <p>&nbsp;</p>
                    <img src="@/assets/logo_rectangle.png" style="width:100%;">
                </el-col>
                <el-col :span="8">
                    <div style="text-align: right;">
                        <h3 style="font-size:58px;margin:0;">Invoice</h3>
                        <p>Little9 Limited</p>
                        <p>ROOM 18 2/F, Tuspark,<br/>118 Wai Yip Street, Kwun<br/>Tong, Kowloon, Hong Kong</p>
                        <p>VAT No. 80226589</p>
                    </div>
                </el-col>
                <el-col>
                    <p></p>
                    <p>Billing to:</p>
                    <p v-html="advInfo.billing_info"></p>
                </el-col>
                <el-col>
                    <p>&nbsp;</p>
                    <p>Billing currency: {{ invoiceObj[invoiceType].iconText }}</p>
                    <p>Invoice Date: {{ nowDate }}</p>
                    <p>Invoice No. {{ invoiceNo }}</p>
                    <p>Item: Mobile Advertising Services</p>
                    <p>&nbsp;</p>
                </el-col>
                <el-col>
                    <el-table
                        :data="exportList"
                        style="width:100%;"
                        stripe
                        border
                        class="export-list-table"
                        cell-class-name="export-list-table-cell"
                        header-row-class-name="export-list-table-header"
                    >
                        <el-table-column prop="time" label="Month" align="center" />
                        <el-table-column prop="confirm_amount" align="center" :label="`Amount(${invoiceObj[invoiceType].iconText})`" />
                    </el-table>
                </el-col>
                <el-col>
                    <div>
                        <p>&nbsp;</p>
                        <p>Payment details:</p>
                        <p>Bank info:</p>
                        <p>Account name: little9 Limited</p>
                        <p>Bank account number: 47412492277</p>
                        <p>Bank code: 003</p>
                        <p>Branch code: 474</p>
                        <p>SWIFT code: SCBLHKHH</p>
                        <p>Bank name: Standard Chartered Bank (Hong Kong) Ltd	</p>
                        <p>Bank address: 32nd Floor, 4-4A Des Voeux Road Central Hong Kong SAR</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>Payoneer: mia@little9.top</p>
                        <p>Paypal: yhui4719@gmail.com</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <p>For and on behalf of Little9 Limited</p>
                    </div>
                    
                    <div class="invoice-img">
                        <img src="../../assets/invoice.png" width="544px" />
                    </div>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
</template>

<script>
export default {
    props: {
        invoiceType: {
            type: String,
        },
        advInfo: {
            type: Object,
        },
        exportList: {
            type: Array,
        },
        nowDate: {
            type: String,
        },
        invoiceNo: {
            type: String,
        }
    },
    data() {
        return {
            invoiceObj: {
                'USD': {
                    iconText: 'USD',
                    icon: '$',
                    emailBody: `
Hello Team,

Please check attached of {invoice_name},please let me know if you have any questions. Below please find payment details:

Account name: Little9 Limited

Thanks!

Best Regards,
Little9`
                },
                'EUR': {
                    iconText: 'EUR',
                    icon: '€',
                    emailBody: `
Hello Team,

Please check attached of {invoice_name},please let me know if you have any questions. Below please find payment details:

Account name: Little9 Limited

Thanks!

Best Regards,
Little9`
                },
            },
        }
    },
    computed: {
        tableData() {
            return this.exportList.map((item, key) => {
                if (this.exportList.length - 1 != key) {
                    item.item = 'Mobile Advertising Services';
                }
                item.confirm_amount = item.confirm_amount ? Number(item.confirm_amount).toFixed(2) : '0.00';
                return item;
            })
        }
    }
}
</script>

<style scoped>
.pdf-review {
    padding: 100px 120px;
    color: #000;
    position: relative;
    font-family: Arial !important;
    :deep() {
        p {
            font-size: 18px;
            margin: 12px 0;
        }
    }
    .sub-title {
        font-size: 26px !important;
        font-weight:700;
    }
    
}
.invoice-img {
    position: absolute;
    right:0px;
    bottom:0px;
}
.pdf-title {
    /* font-size: 46px; */
    font-size: 48px !important;
    font-weight: 800;
}
</style>
<style>
.export-list-table {
    border-right: 1px solid #000 !important;
    border-bottom: 1px solid #000 !important;
}
.export-list-table-cell {
    font-size: 18px;
    border-left: 1px solid #000 !important;
    border-top: 1px solid #000 !important;
}
.export-list-table-header >th {
    background-color: #f8bdc4;
    color: #000000;
    font-size: 18px;
    font-weight: 800;
    line-height: 18px;
    border-left: 1px solid #000 !important;
    border-top: 1px solid #000 !important;
}
</style>